import ThreeUserProfile from './ThreeUserProfile';

export default ThreeUserProfile;
